var identity = require('./identity');

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the array-like object.
 */
function baseCastFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = baseCastFunction;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_baseCastFunction.js
 ** module id = 1393
 ** module chunks = 0
 **/